module.exports = __webpack_public_path__ + "img/m-hd.b02888c0.webp";